import { CmsThemes } from 'src/lib/constants';

// SITE-6095: hero CTA buttons fill the content container on mobile
const fullWidthMobileButtons = {
  width: { xs: '100%', sm: 'unset' },
};

export const buttonGroupStyles = {
  [CmsThemes.WEB2]: {
    ...fullWidthMobileButtons,
    '& > a, & > button': fullWidthMobileButtons,
  },
  [CmsThemes.WEB3]: {
    ...fullWidthMobileButtons,
    '& > a, & > button': {
      ...fullWidthMobileButtons,
      justifyContent: 'center',
    },
  },
};

// CTA buttons embedded directly in hero rich text render without a
// button-group wrapper, as direct children of the hero's content stack
export const embeddedButtonStyles = {
  [CmsThemes.WEB2]: {
    '& > .btn': fullWidthMobileButtons,
  },
  [CmsThemes.WEB3]: {
    '& > .btn': {
      ...fullWidthMobileButtons,
      justifyContent: 'center',
    },
  },
};
